import React from 'react';
import styled from '@emotion/styled';

const HeaderContainer = styled.div`
  position: relative;
  text-align: center;
  margin: 1rem 0 2rem;
  padding: 1.5rem;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    z-index: -1;
  }
  
  @media (max-width: 768px) {
    margin: 0.5rem 0 1.5rem;
    padding: 1.25rem 1rem;
  }
`;

const Title = styled.h1`
  position: relative;
  margin: 0;
  font-size: 2.25rem;
  font-weight: bold;
  line-height: 1.2;
  z-index: 2;
  word-break: break-word;
  hyphens: auto;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const Highlight = styled.span`
  color: #ff3333;
`;

const PageHeader = ({ title, highlightWord, highlightWords }) => {
  const words = Array.isArray(highlightWords) && highlightWords.length > 0
    ? highlightWords
    : (highlightWord ? [highlightWord] : []);

  if (words.length === 0) {
    return (
      <HeaderContainer>
        <Title>{title}</Title>
      </HeaderContainer>
    );
  }

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${words.map(escapeRegExp).join('|')})`, 'g');
  const parts = title.split(regex);

  return (
    <HeaderContainer>
      <Title>
        {parts.map((part, idx) => (
          words.includes(part)
            ? <Highlight key={idx}>{part}</Highlight>
            : <React.Fragment key={idx}>{part}</React.Fragment>
        ))}
      </Title>
    </HeaderContainer>
  );
};

export default PageHeader;
